import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

const numberFormats = {
  // https://kazupon.github.io/vue-i18n/guide/number.html#custom-formatting
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
  'en-GB': {
    currency: {
      style: 'currency',
      currency: 'GBP',
    },
  },
};

export default new VueI18n({
  locale: 'en',
  messages,
  numberFormats,
});
